;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/account/:slug*\",\"regex\":\"^/account/(.+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/relationship/:id\",\"regex\":\"^/relationship/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/shared/:userId\",\"regex\":\"^/shared/([^/]+)$\",\"paramNames\":[\"userId\"],\"hasOptionalPrefix\":false},{\"path\":\"/blog/:slug\",\"regex\":\"^/blog/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/guardian-invite/:token\",\"regex\":\"^/guardian-invite/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/invite/:token\",\"regex\":\"^/invite/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/accept-terms\"},{\"path\":\"/login\"},{\"path\":\"/onboarding\"},{\"path\":\"/onboarding/connect\"},{\"path\":\"/billing\"},{\"path\":\"/dashboard\"},{\"path\":\"/my-youtube\"},{\"path\":\"/privacy\"},{\"path\":\"/terms\"},{\"path\":\"/admin\"},{\"path\":\"/billing/complete\"},{\"path\":\"/blog\"},{\"path\":\"/come-back\"},{\"path\":\"/faq\"},{\"path\":\"/invite-error\"},{\"path\":\"/invite-success\"},{\"path\":\"/parental-monitoring-app\"},{\"path\":\"/pricing\"},{\"path\":\"/senior-protection\"},{\"path\":\"/settings\"},{\"path\":\"/sms-monitoring\"},{\"path\":\"/unsubscribe\"},{\"path\":\"/youtube-monitoring-app\"},{\"path\":\"/youtube-parental-controls\"}],\"isrRoutes\":[\"/blog/:slug\"]}";globalThis["_sentryNextJsVersion"] = "16.4.0";import * as Sentry from "@sentry/nextjs";
import { SENTRY_DATA_COLLECTION } from "@/lib/sentry-data-collection";

export const sentryClientOptions: Sentry.BrowserOptions = {
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,

  // Sample 10% of traces in production; 100% in development
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,

  // Never send PII — SMS content, phone numbers, child data
  dataCollection: SENTRY_DATA_COLLECTION,

  // Sentry's Next.js client SDK rewrites every absolute-URL stack frame's
  // origin to the literal "app://", including frames from third-party
  // browser extensions — so extension noise becomes indistinguishable from
  // our own bundle (YOUGUARD-NEXTJS-9: "app:///executors/200.js" reported as
  // an in-app error). Only our own output lives under /_next/, so scope
  // capture to it.
  allowUrls: [/\/_next\//],

  // Browser translation tools (e.g. Chrome/Google Translate) rewrite text
  // nodes into <font> wrappers outside React's control; when React's own
  // commit phase later calls removeChild/insertBefore on a node Translate
  // already moved, the browser throws — not reproducible, not fixable from
  // app code (YOUGUARD-NEXTJS-A: confirmed via breadcrumbs showing <font>
  // element clicks and Arabic-translated tooltip text right before the error).
  //
  // Safari Web Extensions' content scripts throw "Invalid call to
  // runtime.sendMessage(). Tab not found." as an unhandled rejection with no
  // stack frames, so allowUrls above can't catch it. YouGuard's web app never
  // calls runtime.sendMessage (YOUGUARD-NEXTJS-E, iOS Safari on /invite).
  ignoreErrors: [
    /Failed to execute 'removeChild' on 'Node'/,
    /Failed to execute 'insertBefore' on 'Node'/,
    /Invalid call to runtime\.sendMessage\(\)/,
  ],

  beforeSend(event) {
    // Drop 4xx client errors — expected, not actionable
    const status = event.contexts?.response?.status_code as number | undefined;
    if (status && status >= 400 && status < 500) return null;

    // Sentinel's browser QA throws a deliberate "sentinel-ctl-*" error to prove it captures JS errors;
    // it raised YOUGUARD-NEXTJS-C and -D as Squasher alerts on 2026-09-28. Not our code.
    if (event.exception?.values?.some((v) => v.value?.startsWith("sentinel-ctl-"))) return null;

    // Strip auth headers and request bodies
    if (event.request) {
      event.request.data = undefined;
      if (event.request.headers) {
        delete event.request.headers["authorization"];
        delete event.request.headers["cookie"];
      }
    }
    // Strip breadcrumb data (may contain SMS content)
    const breadcrumbValues = event.breadcrumbs?.values;
    if (Array.isArray(breadcrumbValues)) {
      breadcrumbValues.forEach((b) => {
        if (b.data) {
          delete b.data["body"];
          delete b.data["response_body"];
          delete b.data["request_body"];
        }
      });
    }

    return event;
  },
};

Sentry.init(sentryClientOptions);

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
